import * as actionTypes from "../actionTypes";

export const createPoojaCategory = (payload) => ({
  type: actionTypes.CREATE_POOJA_CATEGORY,
  payload,
});
export const getPoojaCategory = () => ({
  type: actionTypes.GET_POOJA_CATEGORY_LIST,
});
export const setPoojaCategory = () => ({
  type: actionTypes.SET_POOJA_CATEGORY_LIST,
});
export const updatePoojaCategory = (payload) => ({
  type: actionTypes.UPDATE_POOJA_CATEGORY,
  payload,
});
export const deletePoojaCategory = (payload) => ({
  type: actionTypes.DELETE_POOJA_CATEGORY,
  payload,
});
export const updatePoojaCategoryStatus = (payload) => ({
  type: actionTypes.UPDATE_POOJA_CATEGORY_STATUS,
  payload,
});
